var map = {
	"./add.svg": 220,
	"./arrowDown.svg": 115,
	"./arrowUp.svg": 116,
	"./br.svg": 221,
	"./camera.svg": 222,
	"./copy.svg": 223,
	"./delete.svg": 224,
	"./done.svg": 225,
	"./en.svg": 226,
	"./es.svg": 227,
	"./faceFrame.svg": 228,
	"./face_overlay.svg": 229,
	"./restart.svg": 230,
	"./settings-white.svg": 231,
	"./success.svg": 232,
	"./take_photo.svg": 233,
	"./translate.svg": 117,
	"./us.svg": 234,
	"./values.svg": 235,
	"./white-camera.svg": 236,
	"./white-check.svg": 237,
	"./white-restart.svg": 238
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 219;